/* VITTORI LUVANO – animaciones al hacer scroll (ligero, sin dependencias) */
(() => {
  if (window.__vlReveal) return; window.__vlReveal = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (root = document) => {
    const els = root.querySelectorAll('[data-vl-reveal]:not(.vl-is-visible)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('vl-is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('vl-is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(e => io.observe(e));
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  if (document.readyState !== 'loading') init();
})();
